import React from "react";

import AccountBalanceWallet from "@mui/icons-material/AccountBalanceWallet";
import Event from "@mui/icons-material/Event";
import AccountCircle from "@mui/icons-material/AccountCircle";
import AccessTime from "@mui/icons-material/AccessTime";
import Help from "@mui/icons-material/Help";

const NavbarConfig = [
  {
    title: "Outstanding Fees",
    route: "/outstanding-fees",
    icon: <AccountBalanceWallet />,
    treasurerOrCaptainOnly: true,
  },
  {
    title: "{{AdminType}} Events",
    route: "/events/admin",
    icon: <Event />,
    treasurerOrCaptainOnly: true,
    badgeKeys: ["adminUnreadEventMessages"],
  },
  {
    title: "Your Events",
    route: "/events",
    icon: <Event />,
    badgeKeys: ["unreadEventMessages", "unpaidEvents"],
  },
  {
    title: "Admin Availability",
    route: "/availability/admin",
    icon: <AccessTime />,
    treasurerOrCaptainOnly: true,
    badgeKeys: ["adminUnreadAvailabilityMessages"],
  },
  {
    title: "Your Availability",
    route: "/availability",
    icon: <AccessTime />,
    badgeKeys: [
      "unreadAvailabilityMessages",
      "unrespondedAvailabilityRequests",
    ],
  },
  {
    title: "Your Profile",
    route: "/profile",
    icon: <AccountCircle />,
  },
  {
    title: "FAQs",
    href: "https://slateapp.co.uk/helpandfaq/",
    icon: <Help />,
  },
];

export default NavbarConfig;
